import { preferenciaLigada } from "../preferencias";

/**
 * O som do gol na partida ao vivo, feito na hora pelo Web Audio.
 *
 * Sem arquivo de áudio: um arquivo seria mais peso no pacote que já leva 89 MB
 * de arte, e dois timbres bastam para dizer o que aconteceu sem olhar a tela.
 * O gol a favor sobe (arpejo maior e um "ahh" de torcida, de ruído filtrado); o
 * contra desce, curto e grave. Quem não quer som desliga em Opções.
 */

let contexto: AudioContext | null = null;

function audio(): AudioContext | null {
  if (typeof window === "undefined" || typeof window.AudioContext === "undefined") return null;
  contexto ??= new window.AudioContext();
  // O navegador nasce o contexto suspenso até haver um gesto na página. Quem
  // está vendo a partida já clicou em "Jogar rodada", então retomar funciona.
  if (contexto.state === "suspended") void contexto.resume();
  return contexto;
}

function nota(ctx: AudioContext, frequencia: number, inicio: number, duracao: number, tipo: OscillatorType, volume: number): void {
  const oscilador = ctx.createOscillator();
  const ganho = ctx.createGain();
  oscilador.type = tipo;
  oscilador.frequency.value = frequencia;
  ganho.gain.setValueAtTime(0.0001, inicio);
  ganho.gain.exponentialRampToValueAtTime(volume, inicio + 0.02);
  ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + duracao);
  oscilador.connect(ganho).connect(ctx.destination);
  oscilador.start(inicio);
  oscilador.stop(inicio + duracao + 0.05);
}

/** O "ahh" da torcida: ruído branco passando por um filtro na faixa da voz. */
function torcida(ctx: AudioContext, inicio: number): void {
  const segundos = 1.6;
  const buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * segundos), ctx.sampleRate);
  const dados = buffer.getChannelData(0);
  for (let i = 0; i < dados.length; i += 1) dados[i] = Math.random() * 2 - 1;
  const fonte = ctx.createBufferSource();
  fonte.buffer = buffer;
  const filtro = ctx.createBiquadFilter();
  filtro.type = "bandpass";
  filtro.frequency.value = 900;
  filtro.Q.value = 0.8;
  const ganho = ctx.createGain();
  ganho.gain.setValueAtTime(0.0001, inicio);
  ganho.gain.exponentialRampToValueAtTime(0.16, inicio + 0.18);
  ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + segundos);
  fonte.connect(filtro).connect(ganho).connect(ctx.destination);
  fonte.start(inicio);
  fonte.stop(inicio + segundos);
}

export function tocarGol(aFavor: boolean): void {
  if (!preferenciaLigada("somDoJogo")) return;
  try {
    const ctx = audio();
    if (!ctx) return;
    const agora = ctx.currentTime + 0.02;
    if (aFavor) {
      [523.25, 659.25, 783.99, 1046.5].forEach((frequencia, i) =>
        nota(ctx, frequencia, agora + i * 0.1, 0.4, "triangle", 0.16),
      );
      torcida(ctx, agora);
    } else {
      [392, 311.13].forEach((frequencia, i) => nota(ctx, frequencia, agora + i * 0.16, 0.45, "sine", 0.14));
    }
  } catch {
    // Sem áudio no aparelho, o gol continua na tela.
  }
}
